var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('i',{staticClass:"fa fa-spinner fa-pulse fa-lg fa-fw"}),_vm._v(" "),(this.full)?[_vm._v("trwa ładowanie...")]:_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }